import { render, staticRenderFns } from "./popWait.vue?vue&type=template&id=01574854&scoped=true&"
import script from "./popWait.vue?vue&type=script&lang=js&"
export * from "./popWait.vue?vue&type=script&lang=js&"
import style0 from "./popWait.vue?vue&type=style&index=0&id=01574854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01574854",
  null
  
)

export default component.exports